import { render, staticRenderFns } from "./TopPosts.vue?vue&type=template&id=3cd7fa74&scoped=true&"
import script from "./TopPosts.vue?vue&type=script&lang=js&"
export * from "./TopPosts.vue?vue&type=script&lang=js&"
import style0 from "./TopPosts.vue?vue&type=style&index=0&id=3cd7fa74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd7fa74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
installComponents(component, {VCarousel,VCarouselItem})
